
import {Vue, Component, Prop} from "vue-property-decorator";
import CustomChipLink from "@/components/CustomChipLink.vue";
@Component({
    components: {
        CustomChipLink,
    },
})
export default class LogElement extends Vue {

  @Prop({default: {}})
  public log: object;

  get lang(): string {
    return this.$root.$i18n.locale;
  }
}
